// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Panel_containerPanel__zeMPO {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;

  border-radius: 15px;
  width: calc(100% - 30px);
  margin-top: 10px;
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
}

.Panel_containerPanelSinBorde__m3qXI {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;

  border-radius: 15px;
  width: calc(100% - 40px);
  margin-top: 10px;
  margin-bottom: 30px;
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
}

.Panel_containerPrincipal__rgfZ5 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1;
  background-color: var(--gris-fondo);

  border-radius: 15px 15px 0px 0px;
  margin-left: 10px;
  margin-right: 10px;
}

.Panel_containerItems__WSxzI {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  width: 100%;

  padding: 20px;

  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;

  margin-left: 10px;
  margin-right: 10px;
}

.Panel_contenedorFormulario__VBvMZ {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #f8fafc;
  border-width: 1px;
  border-style: solid;
  border-radius: 12px;
  border-color: gray;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Panel.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;;EAEzB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;;EAEzB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAO;EACP,mCAAmC;;EAEnC,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;;EAEX,aAAa;;EAEb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;;EAEnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".containerPanel {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #ffffff;\n\n  border-radius: 15px;\n  width: calc(100% - 30px);\n  margin-top: 10px;\n  padding-left: 20px;\n  padding-top: 20px;\n  padding-right: 20px;\n}\n\n.containerPanelSinBorde {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #ffffff;\n\n  border-radius: 15px;\n  width: calc(100% - 40px);\n  margin-top: 10px;\n  margin-bottom: 30px;\n  padding-left: 20px;\n  padding-top: 20px;\n  padding-right: 20px;\n}\n\n.containerPrincipal {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  background-color: var(--gris-fondo);\n\n  border-radius: 15px 15px 0px 0px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.containerItems {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-content: flex-start;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n\n  padding: 20px;\n\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.contenedorFormulario {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  background-color: #f8fafc;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 12px;\n  border-color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerPanel": `Panel_containerPanel__zeMPO`,
	"containerPanelSinBorde": `Panel_containerPanelSinBorde__m3qXI`,
	"containerPrincipal": `Panel_containerPrincipal__rgfZ5`,
	"containerItems": `Panel_containerItems__WSxzI`,
	"contenedorFormulario": `Panel_contenedorFormulario__VBvMZ`
};
export default ___CSS_LOADER_EXPORT___;
